import React, { FC, useContext } from 'react';
import { styled } from '@grupoboticario/flora-react';

import { CatalogContext, hooks } from 'src/contexts/Catalog';

import { MobileCatalogPage } from './MobileCatalogPage';
import { DesktopCatalogPage } from './DesktopCatalogPage';

import { useKeyboardNavigation } from 'src/components/templates/CatalogPage/CatalogServices';

export type UpdateCatalogData = (
  position: number,
  secondaryPosition?: number,
) => Promise<void>;

const StyledMain = styled('main', {
  height: '-webkit-fill-available',
  '@tablet': {
    height: '100vh',
    overflow: 'hidden',
  },
});

export const CatalogPage: FC = () => {
  hooks.useUpdateURLPageParam();

  const [state] = useContext(CatalogContext);

  useKeyboardNavigation();

  return (
    <StyledMain>
      {state.isDesktop ? <DesktopCatalogPage /> : <MobileCatalogPage />}
    </StyledMain>
  );
};
